import React, { Component } from "react"
import Relay from "react-relay"
import { Link } from "react-router"
import { apiAuth } from "../../api"
import ResourceImage from "./ResourceImage"
import { FormattedMessage } from "react-intl"
import { default as profileMessages } from "../../messages/profile"
import { getStyles, getStyleTag } from "../../styles/dynamicStyles"

class ScrapbookHeader extends Component {
  state = {
    userValues: {}
  }

  componentDidMount() {
    apiAuth("get", "user").then(userValues => this.setState({ userValues }))
  }

  getFavourites = () => {
    const {
      viewer: {
        defaults,
        user_sets: { edges: userSetEdges }
      }
    } = this.props
    const favourites =
      userSetEdges.length > 0 ? userSetEdges[0].node.favourites.edges : []
    const unique = []

    return favourites
      .concat(defaults ? defaults.edges : [])
      .reduce((resources, edge) => {
        const resource = edge.node
        if (resources.length < 5 && unique.indexOf(resource.id) < 0) {
          resources.push(resource)

          unique.push(resource.id)
        }

        return resources
      }, [])
  }

  render() {
    const favourites = this.getFavourites()
    const background = favourites.slice(-1)[0]
    const byLine = this.state.userValues && this.state.userValues.name

    return (
      <div>
        {getStyleTag([
          "rich-page-header__title",
          "rich-page-header__bg",
          "c-tabs__tab",
          "rich-page-header__content"
        ])}
        {background && (
          <ResourceImage
            resource={background}
            className="rich-page-header__bg"
          />
        )}
        <div
          className="rich-page-header__content"
          style={getStyles([
            "rich-page-header__content",
            "rich-page-header__content--centered"
          ])}
        >
          <div
            className="row column"
            style={getStyles("rich-page-header__content__row")}
          >
            <h1
              className="rich-page-header__title"
              style={getStyles([
                "rich-page-header__title",
                "rich-page-header__bg__title"
              ])}
            >
              <FormattedMessage {...profileMessages.myScrapbook} />
            </h1>
            {byLine && (
              <h3
                className="rich-page-header__subtitle"
                style={getStyles("rich-page-header__subtitle")}
              >
                <em>
                  <FormattedMessage {...profileMessages.by} />
                </em>{" "}
                {byLine}
              </h3>
            )}
            <div className="p-scrapbook__head-images">
              {favourites.slice(0, 4).map(resource => (
                <Link
                  className="p-scrapbook__head-image"
                  key={resource.id}
                  title={resource.title}
                  to={`/item/${resource.id}`}
                >
                  <ResourceImage resource={resource} />
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Relay.createContainer(ScrapbookHeader, {
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        defaults: resources(
          first: 5
          access_rights: "published"
          orphan: true
        )
        {
          edges {
            node {
              id
              title
              ${ResourceImage.getFragment("resource")}
            }
          }
        }
        user_sets(first: 1) {
          edges {
            node {
              favourites: resources(first: 5) {
                edges {
                  node {
                    id
                    title
                    ${ResourceImage.getFragment("resource")}
                  }
                }
              }
            }
          }
        }
      }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/modules/ScrapbookHeader.js